module.exports = __webpack_public_path__ + "static/media/climate_workplacePollutants_4_surfaceWaterPollutants.3cb5583f.jpg";